import commonPostTypeConfig from '../../common/postTypes/chat/message'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'message',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
